import copy from "copy-to-clipboard";
import { Box, Button, Input } from "..";
import { useStyles } from "./styles";

interface ICopyInputProps {
  label: string;
  text: string;
  onCopy?: () => void;
  inputTestId?: string;
  buttonTestId?: string;
}

const CopyInput = ({
  label,
  text,
  onCopy,
  inputTestId,
  buttonTestId,
}: ICopyInputProps) => {
  const styles = useStyles();

  const handleCopy = () => {
    copy(text);

    if (onCopy) {
      onCopy();
    }
  };

  return (
    <Box display="flex" width="100%">
      <Box mr={1} flexGrow={1}>
        <Input
          inputProps={{
            readOnly: true,
            "data-testid": inputTestId,
          }}
          className={styles.input}
          fullWidth
          disabled
          value={text}
          size="sm"
        />
      </Box>

      <Button
        variant="ghost"
        color="dark"
        disabled={!text}
        onClick={handleCopy}
        size="md"
        data-testid={buttonTestId}
      >
        {label}
      </Button>
    </Box>
  );
};

export default CopyInput;
